import Phaser from 'phaser';

import { BootScene } from './scenes/Boot';
import { MenuScene } from './scenes/Menu';
import { GameScene } from './scenes/Game';
import { ResultsScene } from './scenes/Results';
import { ShopScene } from './scenes/Shop';

export const GAME_WIDTH = 360;
export const GAME_HEIGHT = 640;

const dpr = Math.min(window.devicePixelRatio || 1, 2);

export const phaserConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: GAME_WIDTH * dpr,
  height: GAME_HEIGHT * dpr,
  backgroundColor: '#0f172a',
  parent: 'game',
  scene: [BootScene, MenuScene, ShopScene, GameScene, ResultsScene],
  fps: {
    target: 60,
    forceSetTimeOut: false,
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
};

export const createPhaserGame = (parent?: string | HTMLElement): Phaser.Game =>
  new Phaser.Game({
    ...phaserConfig,
    ...(parent ? { parent } : {}),
  });
